import { type TrackByFunction } from '@angular/core';
import { ISelectOption, type IGroup } from '@principle-theorem/shared';
import { TrackByFunctions } from '../track-by';

export interface IMatSelectOptions<T> {
  options: ISelectOption<T>[];
  trackBy: TrackByFunction<ISelectOption<T>>;
}

export type IconInputOption = { icon: string; value: string | number };
export type LabeledInputOption = { label: string; value: string | number };
export type OptionInput =
  | string
  | number
  | IconInputOption
  | LabeledInputOption;

export function matSelectOptions<T>(
  options: ISelectOption<T>[]
): IMatSelectOptions<T> {
  return {
    options,
    trackBy: TrackByFunctions.label<ISelectOption<T>>(),
  };
}
export interface IMatSelectGroupOptions<Group, Items> {
  groups: IGroup<ISelectOption<Items>, Group>[];
  trackByGroup: TrackByFunction<IGroup<ISelectOption<Items>, Group>>;
  trackByOption: TrackByFunction<ISelectOption<Items>>;
}

export function matSelectGroupOptions<Group, Items>(
  groups: IGroup<ISelectOption<Items>, Group>[]
): IMatSelectGroupOptions<Group, Items> {
  return {
    groups,
    trackByGroup:
      TrackByFunctions.field<IGroup<ISelectOption<Items>, Group>>('group'),
    trackByOption: TrackByFunctions.label<ISelectOption<Items>>(),
  };
}
